<template>
  <div class="shadow rounded items-center">
    <stats-date-picker v-slot:default="{dateFrom, dateTo, interval}">
      <key-figures v-slot:default="{keyFigures}" :dateFrom="dateFrom" :dateTo="dateTo">
        <stats-tabs>
          <stats-tab title="Ticket Umsatz" :subtitle="currency(keyFigures.revenue)">
            <line-chart-ticket-revenue :dateFrom="dateFrom" :dateTo="dateTo" :interval="interval"></line-chart-ticket-revenue>
          </stats-tab>

          <stats-tab title="Verkaufte Tickets" :subtitle="keyFigures.ticketCount">
            <bar-chart-ticket-count :dateFrom="dateFrom" :dateTo="dateTo" :interval="interval"></bar-chart-ticket-count>
          </stats-tab>

          <stats-tab title="Bestellungen" :subtitle="keyFigures.ordersCount">
            <bar-chart-order-count :dateFrom="dateFrom" :dateTo="dateTo" :interval="interval"></bar-chart-order-count>
          </stats-tab>
        </stats-tabs>
      </key-figures>
    </stats-date-picker>
  </div>
</template>

<script>
import StatsDatePicker from "@/components/statistics/StatsDatePicker";
import StatsTabs from "@/components/statistics/StatsTabs";
import StatsTab from "@/components/statistics/StatsTab";

import LineChartTicketRevenue from "@/components/statistics/LineChartTicketRevenue";
import BarChartTicketCount from "@/components/statistics/BarChartTicketCount";
import BarChartOrderCount from "@/components/statistics/BarChartOrderCount";
import KeyFigures from "@/components/statistics/KeyFigures";

import numeral from "numeral";
import statisticClient from "@/api/central/statistics";

export default {
  components: {
    LineChartTicketRevenue,
    BarChartTicketCount,
    BarChartOrderCount,
    StatsDatePicker,
    StatsTabs,
    StatsTab,
    KeyFigures
  },

  methods: {
    currency(value) {
      return numeral(value).format("0,0[.]00 $");
    }
  }
};
</script>
